import React from 'react'
import styles from './prompt-dialog.module.css'
import {sendIntelligentPromptView} from '../../lib/xes/log'

class promptDialog extends React.Component {
    constructor(props) {
        super(props)
    }
    clickToCheck(){
        /* 打点3.0 前往检查 */
        sendIntelligentPromptView(
            'submit_click_check',
            this.props.isBlank ? 'no_change' : 'fail'
        )
        this.props.onClosePromptDialog()
    }
    clickViewTips(){
        /* 打点3.0 查看提示 */
        sendIntelligentPromptView(
            'submit_click_view',
            this.props.isBlank ? 'no_change' : 'fail'
        )
        this.props.onClosePromptDialog()
    }
    clickStillSubmit(){
        /* 打点3.0 仍要提交 */
        sendIntelligentPromptView(
            'still_submit',
            this.props.isBlank ? 'no_change' : 'fail'
        )
        this.props.onSubmit()
    }
    render () {
        return (
            <div className={styles.wraper}>
                <div className={styles.card}>
                    {/* 关闭按钮 */}
                    <a className={ styles.btnClose} onClick={ () => { this.props.onClosePromptDialog() } } href='javascript:void(0)'></a>
                    {/* 文案&按钮 */}
                    <div  className = {styles.tipActiveBtnText} >
                        <h3 className = {styles.msg}>{this.props.titleText}</h3>
                        <p className = {styles.tips}>{this.props.descText}</p>
                        <div className={styles.btnActive}>
                            {
                                this.props.toCheck ?
                                <a onClick={() => { this.clickToCheck() }} className={styles.btnZsd} href='javascript:void(0)'></a>
                                : <a onClick={() => { this.clickViewTips() }} className={styles.btnJtsl} href='javascript:void(0)'></a>
                            }
                            <a onClick={() => { this.clickStillSubmit() }} className={(this.props.showBtnSubmit ? '' : styles.hide) + ' ' + styles.btnSubmit} href='javascript:void(0)'></a>
                        </div>
                    </div>
                
                </div>
            </div>
        )
    }
}
export default promptDialog